<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>水資源管理</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>以煤炭發電的火力發電廠需要使用大量工業用水，和平電力發電過程中每天約產生 533 噸的作業廢水，為了有效再利用，2021 年起和平電力自行開發並攜手國立宜蘭大學合作研究，使用全台燃煤電廠中唯一「奈米濾膜及逆滲透膜系統」，逐步回收廢水，2023 年相較 2020 年減少 10.4 萬噸排水量。此項系統於 2024 年取得 I832462 號專利，並將作業廢水用於脫硫及海水電解系統。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="imgContainer2-1"></div>
        <div class="milestone">
          <div class="block0">
            <div class="dash"></div>
          </div>
          <div class="block1">
            <div class="left">
              <div class="item item1 phoneHidden">
                <div class="year">2022 年</div>
                <br>
                <!-- <div class="info"> -->
                  <div class="imgContainer2-2">
                    <div class="imgTit">與國立宜蘭大學合作研究自力開發奈米濾膜及逆滲透膜系統</div>
                  </div>
                <!-- </div> -->
              </div>
            </div>
            <div class="right">
              <div class="item item1">
                <div class="year">2020 年</div>
                <br>
                <div class="info">
                  <span class="txt1">作業廢水/年</span>
                  <div class="phoneVisable"></div>
                  <i class="fa-solid fa-up-long"></i>
                  <span class="txt2"> 產生 </span>
                  <span class="num num1" ref="num1">533</span>
                  <span class="unit"> 噸</span>
                </div>
                <div class="diagram">
                  <img class="icon" src="../../assets/environmentWater/icon2_01.png">
                  <span class="txt1">×365</span>
                  <span class="txt2">天</span>
                  <span class="unit">單位：千噸/桶</span>
                </div>
              </div>
              <div class="item item1L phoneVisable">
                <div class="year">2022 年</div>
                <br>
                <div class="imgContainer2-2">
                  <div class="imgTit">與國立宜蘭大學合作研究自力開發奈米濾膜及逆滲透膜系統</div>
                </div>
              </div>
              <div class="item item2">
                <div class="year">2023 年</div>
                <br>
                <div class="info">
                  <span class="txt1">作業廢水/年</span>
                  <div class="phoneVisable"></div>
                  <i class="fa-solid fa-down-long"></i>
                  <span class="txt2"> 減少 </span>
                  <span class="num num2" ref="num2">104000</span>
                  <span class="unit"> 噸</span>
                </div>
                <img class="icon" src="../../assets/environmentWater/pic2_03.png">
              </div>
            </div>
            <div class="clear"></div>
            <div class="nextArrow">
              <div class="stick"></div>
              <div class="tri"></div>
            </div>
          </div>
          <div class="block2">
            <div class="year">2024 年 4 月</div>
            <img class="icon" src="../../assets/environmentWater/icon2_02.png">
            <div class="highlight">建置雨水回收系統</div>
            <div class="desp">蒐集的雨水經過沉沙、除油、過濾後再利用於脫硫系統。</div>
            <div class="left">
              <div class="imgContainer2-4">
                <div class="imgTit">雨水回收槽</div>
              </div>
            </div>
            <div class="right">
              <!-- <div class="info">
                <span class="txt1">雨水回收/年</span>
                <div class="phoneVisable"></div>
                <i class="fa-solid fa-arrows-rotate"></i>
                <span class="txt2"> 回收 </span>
                <span class="num num3" ref="num3">53082</span>
                <span class="unit"> 噸</span>
              </div>
              <img class="imgContainer2-5" src="../../assets/environmentWater/pic2_05.png"> -->
              <div class="rainDischargeTxt">雨水排放口改造示意圖</div>
              <img class="imgContainer2-6" src="../../assets/environmentWater/pic2_06.png">
            </div>
            <div class="clear"></div>
            <!-- <div class="nextArrow">
              <div class="dash"></div>
              <div class="tri"></div>
            </div> -->
          </div>
          <!-- <div class="block3">
            <div class="year">2025 年</div>
            <img class="icon" src="../../assets/environmentWater/icon2_03.png">
            <div class="highlight">目標 2025 年和平電廠<br>作業廢水 <span class="num4" ref="num4">100</span>% 回收再利用</div>
          </div> -->
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Util, ImgContainerAutoResize, NumRun } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'EnvironmentWater',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      num1BoundingBottom: 0,
      num2BoundingBottom: 0,
      num3BoundingBottom: 0,
      num4BoundingBottom: 0,
      num1Height: 0,
      num2Height: 0,
      num3Height: 0,
      num4Height: 0,
      isShowNum1: false,
      isShowNum2: false,
      isShowNum3: false,
      isShowNum4: false
    }
  },
  methods:{
    showNum1: function() {
      this.num1BoundingBottom = (this.$refs.num1 as HTMLElement).getBoundingClientRect().bottom;
      this.num1Height = (this.$refs.num1 as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (this.num1BoundingBottom + 100)) {
        if(!this.isShowNum1) {
          this.isShowNum1 = true;
          new NumRun(document.querySelector(".num1") as HTMLElement, 500);
        }
      }
    },
    showNum2: function() {
      this.num2BoundingBottom = (this.$refs.num2 as HTMLElement).getBoundingClientRect().bottom;
      this.num2Height = (this.$refs.num2 as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (this.num2BoundingBottom + 100)) {
        if(!this.isShowNum2) {
          this.isShowNum2 = true;
          new NumRun(document.querySelector(".num2") as HTMLElement, 500);
        }
      }
    },
    showNum3: function() {
      this.num3BoundingBottom = (this.$refs.num3 as HTMLElement).getBoundingClientRect().bottom;
      this.num3Height = (this.$refs.num3 as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (this.num3BoundingBottom + 100)) {
        if(!this.isShowNum3) {
          this.isShowNum3 = true;
          new NumRun(document.querySelector(".num3") as HTMLElement, 500);
        }
      }
    },
    showNum4: function() {
      this.num4BoundingBottom = (this.$refs.num4 as HTMLElement).getBoundingClientRect().bottom;
      this.num4Height = (this.$refs.num4 as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (this.num4BoundingBottom + 100)) {
        if(!this.isShowNum4) {
          this.isShowNum4 = true;
          new NumRun(document.querySelector(".num4") as HTMLElement, 500);
        }
      }
    }
  },
  mounted() {
    setTimeout( () => {
      this.showNum1();
      this.showNum2();
      // this.showNum3();
      // this.showNum4();
    }, 100);

    window.addEventListener("scroll", () => {
      this.showNum1();
      this.showNum2();
      // this.showNum3();
      // this.showNum4();
    });

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.7);
    document.querySelectorAll(".imgContainer2-2").forEach( (elem) => {
      new ImgContainerAutoResize(elem as HTMLElement, 0.75);
    });
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-4") as HTMLElement, 0.7);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/environmentWater/kv.webp");
  /* background: url("@/assets/environmentWater/kv.webp"); */
  background-position: center, center;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 p {
  margin: 0;
  line-height: 2em;
}

.sect2 .ctx{
  padding: 10px 0 60px;
}

.sect2 .imgContainer2-1 {
  position: relative;
  border-radius: 30px;
  background: url(../../assets/environmentWater/pic2_01.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .phoneVisable {
  display: none;
}

.sect2 .block0 {
  text-align: center;
}

.sect2 .block0 .dash {
  height: 80px;
  display: inline-block;
  border-right: dashed 10px #F4CBB9;
}

.sect2 .block1 {
  position: relative;
}

.sect2 .block1 .left {
  width: 50%;
  padding: 0 60px 0 0;
  box-sizing: border-box;
  float: left;
  position: relative;
}

.sect2 .block1 .right {
  width: 50%;
  padding: 0 0 0 60px;
  box-sizing: border-box;
  float: right;
  position: relative;
}

.sect2 .block1 .item {
  padding: 0 0 60px;
  box-sizing: border-box;
}

.sect2 .block1 .item .year {
  /* width: 150px; */
  margin: auto;
  padding: 0 25px;  
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
  background: #e99776;  
}

.sect2 .block1 .item .info {
  margin: 0 0 20px;
  font-size: 20px;
  text-align: left;
}

.sect2 .block1 .item .info .txt1 {
  padding: 5px 20px;
  box-sizing: border-box;
  border-radius: 100px;
  color: #fff;
  background: #000;
}

.sect2 .block1 .item .info .fa-up-long,
.sect2 .block1 .item .info .fa-down-long {
  margin: 0 5px 0 10px;
  display: inline-block;
  font-size: 32px;
  color: #e99776;
  transform: translateY(3px);
}

.sect2 .block1 .item .info .num {
  display: inline-block;
  line-height: 1em;
  font-family: arial;
  font-weight: bold;
  font-size: 56px;
  color: #0c5f99;
  opacity: 0;
  transform: translateY(10px);
}

.sect2 .block1 .left .item .year {
  position: absolute;
  right: -5px;
}

.sect2 .block1 .right .item .year {
  position: absolute;
  left: -5px;
}

.sect2 .block1 .left .item1 {
  margin: 60px 0 0;
}

.sect2 .block1 .left .item1 .imgContainer2-2,
.sect2 .block1 .right .item1L .imgContainer2-2 {
  margin: 20px 0 0;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: url(../../assets/environmentWater/pic2_02.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .block1 .left .item1 .imgContainer2-2 .imgTit,
.sect2 .block1 .right .item1L .imgContainer2-2 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect2 .block1 .right .item1 .diagram .icon {
  width: 75px;
  vertical-align: bottom;
}

.sect2 .block1 .right .item1 .diagram .txt1 {
  margin: 0 5px;
  font-size: 56px;
  color: #0c5f99;
}

.sect2 .block1 .right .item1 .diagram .txt2 {
  font-size: 20px;
}

.sect2 .block1 .right .item1 .diagram .unit {
  margin: 0 0 0 20px;
  padding: 0 5px 2px;
  box-sizing: border-box;
  border: solid 1px #000;
  font-weight: 900;
  font-size: 14px;
}

.sect2 .block1 .right .item2 img {
  width: 100%;
}

.sect2 .block1 .nextArrow {
  width: 40px;
  height: 100%;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  text-align: center;
  /* background: #ccc; */
}

.sect2 .block1 .nextArrow .stick {
  height: 100%;
  display: inline-block;
  border-right: solid 10px #F4CBB9;
  transform: translateY(-10px);
}

.sect2 .block1 .nextArrow .tri {
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
  border-style: solid;
  border-width: 25px 20px 0 20px;
  border-color: #F4CBB9 transparent transparent transparent;
}

.sect2 .block2 {
  margin: 10px 0;
  text-align: center;
  position: relative;
}

.sect2 .block2 .year {
  width: 150px;
  margin: auto;
  padding: 0 15px;
  box-sizing: border-box;
  color: #fff;
  background: #e99776;
}

.sect2 .block2 > .icon {
  width: 80px;
  display: block;
  margin: 30px auto 20px;
}

.sect2 .block2 .highlight {
  padding: 5px;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0c5f99;
  border-bottom: solid 1px #0c5f99;
  font-size: 24px;
  color: #0c5f99;
}

.sect2 .block2 .desp {
  margin: 10px 0;
  font-size: 20px;
}

.sect2 .block2 .left {
  width: 45%;
  margin: 30px 0;
  float: left;
}

.sect2 .block2 .left .imgContainer2-4 {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: url(../../assets/environmentWater/pic2_04.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .block2 .left .imgContainer2-4 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect2 .block2 .right {
  width: 45%;
  margin: 30px 0;
  float: right;
  position: relative;
}

.sect2 .block2 .right .info {
  margin: 0 0 20px;
  font-size: 20px;
  text-align: left;
}

.sect2 .block2 .right .info .fa-arrows-rotate {
  margin: 0 10px;
  display: inline-block;
  font-size: 40px;
  color: #e99776;
  transform: translateY(6px);
}

.sect2 .block2 .right .info .txt1 {
  padding: 5px 20px;
  box-sizing: border-box;
  border-radius: 100px;
  color: #fff;
  background: #000;
}

.sect2 .block2 .right .info .num {
  display: inline-block;
  line-height: 1em;
  font-family: arial;
  font-weight: bold;
  font-size: 56px;
  color: #0c5f99;
  opacity: 0;
  transform: translateY(7px);
}

.sect2 .block2 .right .imgContainer2-5 {
  width: 100%;
}

.sect2 .block2 .right .rainDischargeTxt {
  margin: 20px auto;
  padding: 5px 20px 7px 22px;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 100px;
  letter-spacing: 3px;
  font-size: 20px;
  color: #fff;
  background: #0052a1;
}

.sect2 .block2 .right .imgContainer2-6 {
  width: 100%;
}

.sect2 .block2 .nextArrow {
  width: 40px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.sect2 .block2 .nextArrow .dash {
  height: 100px;
  display: inline-block;
  border-right: dashed 10px #F4CBB9;
  transform: translateY(15px);
}

.sect2 .block2 .nextArrow .tri {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 20px 0 20px;
  border-color: #F4CBB9 transparent transparent transparent;
}

.sect2 .block3 {
  margin: 10px 0;
  text-align: center;
}

.sect2 .block3 .year {
  width: 120px;
  margin: auto;
  padding: 0 25px;
  box-sizing: border-box;
  color: #fff;
  background: #e99776;
}

.sect2 .block3 > .icon {
  width: 80px;
  display: block;
  margin: 30px auto 20px;
}

.sect2 .block3 .highlight {
  padding: 5px;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0c5f99;
  border-bottom: solid 1px #0c5f99;
  font-size: 24px;
  color: #0c5f99;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .ctx{
    padding: 40px;
  }

  .sect2 .phoneVisable {
    display: block;
  }

  .sect2 .block1 .left {
    padding: 0 40px 0 0;
  }

  .sect2 .block1 .right {
    padding: 0 0 0 40px;
  }

  .sect2 .block1 .item .info {
    margin: 20px 0;
  }

  .sect2 .block1 .item .info .num {
    margin: 10px 0 0;
    font-size: 40px;
    transform: translateY(5px);
  }

  .sect2 .block1 .right .item1L {
    display: none;
  }

  .sect2 .block1 .right .item1 .diagram .icon {
    width: 14%;
  }

  .sect2 .block1 .right .item1 .diagram .txt1 {
    margin: 0 5px;
    font-size: 32px;
  }

  .sect2 .block1 .right .item1 .diagram .txt2 {
    font-size: 16px;
  }

  .sect2 .block1 .right .item1 .diagram .unit {
    font-size: 10px;
  }

  .sect2 .block2 .right .info .fa-arrows-rotate {
    font-size: 32px;
  }

  .sect2 .block2 .right .info .num {
    margin: 5px 0 0;
    font-size: 40px;
    transform: translateY(5px);
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .ctx{
    padding: 10px 20px 40px;
  }

  .sect2 .phoneVisable {
    display: block;
  }

  .sect2 .block0 .dash {
    border-right: dashed 10px #F4CBB966;
  }

  .sect2 .block1 {
    padding: 0 0 100px;
  }

  .sect2 .block1 .left {
    width: 0;
    padding: 0;
  }

  .sect2 .block1 .left .item {
    display: none;
  }

  .sect2 .block1 .right {
    width: 100%;
    padding: 0;
    z-index: 1;
  }

  .sect2 .block1 .right .item {
    margin: 20px 0;
    padding: 15px;
    box-sizing: border-box;
    border: solid 1px #d8d8d8;
    background: #ffffff88;
  }

  .sect2 .block1 .item .info .num {
    margin: 10px 0 0;
    font-size: 40px;
    transform: translateY(5px);
  }

  .sect2 .block1 .right .item .year {
    width: 120px;
    display: block;    
    position: static;
  }  

  .sect2 .block1 .right .item1 .diagram .icon {
    width: 14%;
  }

  .sect2 .block1 .right .item1 .diagram .txt1 {
    margin: 0 5px;
    font-size: 32px;
  }

  .sect2 .block1 .right .item1 .diagram .txt2 {
    font-size: 16px;
  }

  .sect2 .block1 .right .item1 .diagram .unit {
    font-size: 10px;
  }

  .sect2 .block1 .nextArrow .stick {
    border-right: solid 10px #F4CBB966;
  }

  .sect2 .block2 {
    margin: 10px 0 115px;
    padding: 15px;
    box-sizing: border-box;
    border: solid 1px #d8d8d8;
    background: #ffffff88;
  }

  .sect2 .block2 .highlight {
    font-size: 20px;
  }

  .sect2 .block2 .left {
    width: 100%;
    margin: 20px 0;
  }

  .sect2 .block2 .right {
    width: 100%;
    margin: 20px 0;
    z-index: 1;
  }

  .sect2 .block2 .right .info .fa-arrows-rotate {
    font-size: 28px;
  }

  .sect2 .block2 .right .info .num {
    margin: 5px 0 0;
    font-size: 40px;
  }

  .sect2 .block2 .nextArrow {
    top: 95%;
    bottom: auto;
  }

  .sect2 .block2 .nextArrow .dash {
    height: 120px;
    border-right: dashed 10px #F4CBB966;
  }

  .sect2 .block3 {
    margin: 10px 0;
    padding: 15px 15px 20px;
    box-sizing: border-box;
    border: solid 1px #d8d8d8;
    background: #ffffff88;
  }

  .sect2 .block3 .highlight {
    font-size: 20px;
  }
}
</style>
